module.exports = __webpack_public_path__ + "img/linkedin.94db7e92.png";